import React, { FC } from "react";
import { FormikProvider, useFormik } from "formik";
import { useTranslation } from "react-i18next";
import { Page } from "shared/ui";
import { noop } from "shared/helpers";
import { useModal, useTableSorting } from "shared/hooks";
import { userInitialValues } from "shared/constants";
import { AddOrUpdateUserSchema } from "shared/schemas";
import { useGetRolesForTableQuery } from "shared/api";
import { UpdateUserModal, AddUserModal, UsersTable } from "./ui";

interface UsersProps {}

const Users: FC<UsersProps> = () => {
  const { t } = useTranslation();

  const [isOpenEditUserModal, showEditUserModal, closeEditUserModal] =
    useModal();

  const [isOpenAddUserModal, showAddUserModal, closeAddUserModal] = useModal();

  const { changeSort } = useTableSorting();

  const { data: roles } = useGetRolesForTableQuery({});

  const userRolesList =
    roles?.map((role) => ({
      value: role.id as number,
      label: role.name,
    })) || [];

  const addOrUpdateUserFormik = useFormik({
    initialValues: {
      ...userInitialValues,
    },
    validateOnMount: true,
    validateOnBlur: true,
    validationSchema: AddOrUpdateUserSchema,
    onSubmit: noop,
  });

  return (
    <FormikProvider value={addOrUpdateUserFormik}>
      <Page
        title={t("users-page.title")}
        buttonTitle={t("users-page.add-btn")!}
        onClick={showAddUserModal}
      >
        <UsersTable
          showEditUserModal={showEditUserModal}
          changeSort={changeSort}
        />

        <UpdateUserModal
          isOpenEditUserModal={isOpenEditUserModal}
          closeEditUserModal={closeEditUserModal}
          userRolesList={userRolesList}
        />

        <AddUserModal
          isOpenNewUserModal={isOpenAddUserModal}
          closeAddUserModal={closeAddUserModal}
          userRolesList={userRolesList}
        />
      </Page>
    </FormikProvider>
  );
};

export { Users };
